module.exports = __webpack_public_path__ + "img/svg/games.b4a2e744ac6a56755fccd23edceef043.svg";